import find from 'lodash/find';
import {optionsTransactions, optionsContract, REMOTES} from '../config/selectOptions';
import {TASK_STATUS} from '../config/config';
import messages from './transactions/messages';
import intl from '../intl';
import {truncate} from 'lodash'
import generalMessages from '../containers/generalMessages';

import { useInjectReducer } from './injectReducer';
import { useInjectSaga } from './injectSaga';



export const getTransactionByStatus = (status: string) => {
    const transaction : any = find(optionsTransactions, {'value': status});
    return transaction ? transaction.label : null;
}

export const getRemoteOptionForFavoriteJobs = (value: string) => {
    const transaction : any = find(REMOTES, {'value': value});
    return transaction ? transaction.label : null;
}

export const getPackageSubType = (subType: string) => {
    
    let subTypeDefinision: string = '';

    switch(subType) {
        case "loop_preselection":
            subTypeDefinision = intl.formatMessage(generalMessages.LoopPreselection);  
            break;
        case "loop_preselection_tailor_made":
            subTypeDefinision = intl.formatMessage(generalMessages.LoopPreselectionTailorMade);  
            break;
        case "loop_selection_cbi_interview":
            subTypeDefinision = intl.formatMessage(generalMessages.LoopSelectionCbiInterview);  
            break;
        case "loop_selection_cbi_interview_tailor_made":
            subTypeDefinision = intl.formatMessage(generalMessages.LoopSelectionCbiInterviewTailorMade);  
            break;
        case "loop_selection_standardised_interview":
            subTypeDefinision = intl.formatMessage(generalMessages.LoopSelectionStandardisedInterview);  
            break;
        case "loop_selection_standardised_interview_tailor_made":
            subTypeDefinision = intl.formatMessage(generalMessages.LoopSelectionStandardisedInterviewTailorMade);  
            break;    
        
    }
    
    return subTypeDefinision ;
}




export const onlyUnique = (value: any, index: any, self: any) => {
    return self.indexOf(value) === index;
}


export const truncateMetaDescription = (description: string, lenght?: number) => {
    const descRaw = description.replace(/<[^>]+>/g, ' ');
    const desc = descRaw.replace(/(&nbsp;|<br>|<br \/>)/g, '');;
    
    return truncate(desc, {
    'length': lenght ? lenght : 150,
    'omission': '...'
      }
    )
}




export const getTaskStatus = (status: string) => {
    let sts: string = '';    
    switch(status) {
        case TASK_STATUS.activate_before_payment:
            sts = intl.formatMessage(generalMessages.ApprovedBeforePayed);  
            break;
        case TASK_STATUS.booked:
            sts = intl.formatMessage(generalMessages.Payed);  
            break;
        case TASK_STATUS.creating_price:
            sts = intl.formatMessage(generalMessages.CreatePrice);  
            break;
        case TASK_STATUS.bid_sent:
            sts = intl.formatMessage(generalMessages.BidSent);  
            break;
        case TASK_STATUS.bid_accepted:
            sts = intl.formatMessage(generalMessages.BidAccepted);  
            break;
        case TASK_STATUS.bid_rejected:
            sts = intl.formatMessage(generalMessages.BidRejected);  
            break;
        // case TASK_STATUS.completed:
        //     sts = intl.formatMessage(generalMessages);  
        //     break;    
    }
    
    return sts ;

}

export const getTypeOfService = (type: string) => {

    let typeOfService = 'Oglas';
    
    if(type === 'custom') {
        typeOfService = intl.formatMessage(messages.custom_job);  
    }

    if(type === 'template') {
        typeOfService = intl.formatMessage(messages.template_job);  
    }

    if(type === 'help') {
        typeOfService = intl.formatMessage(messages.help_job);  
    }
    return typeOfService;
}


export const executeScroll = (refElement: any, additionalOffset = 0) => {
    if(refElement) {
        const topOfElement = refElement.current.getBoundingClientRect().top + document.documentElement.scrollTop;

        window.scroll({ top: topOfElement + additionalOffset, behavior: "smooth" });
    }
}


export const executeModalScroll = (refElement: any) => {
    if(refElement) {
    let topOfElement = refElement.current.offsetTop;
    const modal = document.getElementById('modalRightId');
        if(modal) {
        modal.scroll({ top: topOfElement, behavior: "smooth" });
        }  
    }
}


export const useInjectSagaAndReducer =(key: string, reducer: any, saga: any) : void => {
    
    
      useInjectReducer({ key, reducer });
      useInjectSaga({ key, saga });
   
    
}


export const employmentTypeLoopToGoogle = (employmentType: string) => {
    
    const contract: any  = find(optionsContract, {'value': employmentType});
    
    if(contract.value === 'Neodređeno' || contract.value === 'Određeno') {
      return 'FULL_TIME'
    }
    
     
    if(contract.value === 'PPP ugovor' || contract.value === 'Ugovor o delu' || contract.value === 'Dopunski rad') {
        return 'PER_DIEM'
    }


       
    if(contract.value === 'Stručna praksa') {
        return 'INTERN'
    }


    if(contract.value === 'Ostalo') {
        return 'OTHER'
    }



}

